import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDown, ChevronUp } from 'lucide-react';
export function FAQSection() {
  const faqs = [{
    q: '¿Cuánto tiempo tarda el proceso de registro de una LLC en Florida?',
    a: 'El tiempo varía según el estado y el volumen de solicitudes. En Florida, el proceso generalmente toma entre 3 y 10 días hábiles. Te mantenemos informado en cada paso.'
  }, {
    q: '¿Qué es el EIN y para qué lo necesito?',
    a: 'El EIN (Employer Identification Number) es el número de identificación fiscal de tu empresa en USA. Lo necesitas para abrir cuenta bancaria, facturar, contratar y más. Inkova te ayuda a obtenerlo como parte del proceso.'
  }, {
    q: '¿Qué es el Registered Agent y por qué no está incluido?',
    a: 'El Registered Agent es la persona o empresa designada para recibir documentos oficiales en nombre de tu LLC. Es un requisito legal en Florida. No está incluido en el plan porque existen múltiples opciones según tu situación. Te orientamos para que elijas la mejor para tu caso.'
  }, {
    q: '¿Qué pasa si no presento el Annual Report?',
    a: 'Tu empresa puede quedar marcada como inactiva o disuelta por el estado de Florida. Esto afecta tu operación, tu cuenta bancaria y tu credibilidad. Por eso ofrecemos el servicio de Annual Report como mantenimiento anual: para que tu empresa siga activa y en cumplimiento.'
  }, {
    q: '¿Puedo crear una LLC en Florida si soy de otro país?',
    a: 'Sí. No necesitas ser ciudadano ni residente de USA para crear una LLC en Florida. Trabajamos con emprendedores internacionales regularmente.'
  }, {
    q: '¿Qué incluye exactamente la sesión estratégica?',
    a: 'Es una conversación directa contigo para: → Entender tu situación actual → Definir el camino correcto para tu negocio → Responder tus dudas con claridad → Orientarte sobre qué plan se adapta mejor a tu caso. Sin compromiso. Con claridad.'
  }, {
    q: '¿Trabajan solo con Florida o también con otros estados?',
    a: 'Trabajamos principalmente con Florida porque ofrece las mejores condiciones para la mayoría de emprendedores latinos. Sin embargo, si tu situación requiere otro estado, te orientamos para que tomes la decisión correcta.'
  }, {
    q: '¿Tienen algún tipo de garantía?',
    a: 'Nuestro compromiso es entregarte un proceso claro, acompañado y sin sorpresas. Si en algún punto del proceso algo no está claro o no se cumplió como se acordó, lo resolvemos contigo directamente. Somos una empresa pequeña con reputación real. Eso vale más que cualquier garantía genérica.'
  }];
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <section id="faq" className="py-24 bg-white" data-id="element-127">
      <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-128">
        <div className="text-center mb-16" data-id="element-129">
          <h2 className="text-3xl md:text-4xl font-serif text-inkova-primary mb-4" data-id="element-130">
            Preguntas frecuentes
          </h2>
        </div>

        <div className="space-y-4" data-id="element-131">
          {faqs.map((faq, i) => <motion.div key={i} initial={{
          opacity: 0,
          y: 10
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: i * 0.1
        }} className="bg-inkova-light rounded-2xl shadow-sm border border-inkova-accent/20 overflow-hidden" data-id="element-132">
              <button onClick={() => setOpenIndex(openIndex === i ? null : i)} className="w-full px-6 py-5 text-left flex justify-between items-center focus:outline-none" data-id="element-133">
                <span className="font-bold text-lg text-inkova-dark" data-id="element-134">
                  {faq.q}
                </span>
                {openIndex === i ? <ChevronUp className="w-5 h-5 text-inkova-accent flex-shrink-0 ml-4" data-id="element-135" /> : <ChevronDown className="w-5 h-5 text-gray-400 flex-shrink-0 ml-4" data-id="element-136" />}
              </button>

              <AnimatePresence data-id="element-137">
                {openIndex === i && <motion.div initial={{
              height: 0,
              opacity: 0
            }} animate={{
              height: 'auto',
              opacity: 1
            }} exit={{
              height: 0,
              opacity: 0
            }} transition={{
              duration: 0.3
            }} data-id="element-138">
                    <div className="px-6 pb-6 text-gray-700 leading-relaxed font-light border-t border-inkova-accent/10 pt-4" data-id="element-139">
                      {faq.a}
                    </div>
                  </motion.div>}
              </AnimatePresence>
            </motion.div>)}
        </div>
      </div>
    </section>;
}